import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiHandle from "services/apiHandle";

// ==================== Async Thunks ====================

// Get all announcements
export const fetchAnnouncements = createAsyncThunk(
  "announcements/fetchAnnouncements",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiHandle("/announcements", "GET");
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to fetch announcements";
      return rejectWithValue(message);
    }
  }
);

// Get active announcements
export const fetchActiveAnnouncements = createAsyncThunk(
  "announcements/fetchActiveAnnouncements",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiHandle("/announcements/active", "GET");
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Failed to fetch active announcements";
      return rejectWithValue(message);
    }
  }
);

// ==================== Slice ====================

const announcementsSlice = createSlice({
  name: "announcements",
  initialState: {
    announcements: [],
    activeAnnouncements: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearAnnouncementsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Announcements
      .addCase(fetchAnnouncements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.announcements =
          action.payload?.announcements || action.payload || [];
      })
      .addCase(fetchAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Active Announcements
      .addCase(fetchActiveAnnouncements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.activeAnnouncements =
          action.payload?.announcements || action.payload || [];
      })
      .addCase(fetchActiveAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearAnnouncementsError } = announcementsSlice.actions;
export default announcementsSlice.reducer;
